// Define global variables
let selectedTimeDisplay = '';

document.addEventListener('DOMContentLoaded', function() {
  // Generate the date chips for the next 7 days
  generateDateChips();
  const branchData = {
  'riffa': {
    name: 'Riffa Branch',
    address: 'Sh Isa Avenue, 83 Building 207',
    phone: '+973 3984 1271',
    coordinates: { lat: 26.1192432, lng: 50.5661117 },
    timings: {
      openingTime: 9,     // 8 AM
      closingTime: 21.30,    // 8 PM
      breakStart: 13,     // 1 PM
      breakEnd: 16,       // 4 PM
      slotDuration: 30
    }
  },
  'hidd': {
    name: 'Hidd Branch',
    address: 'Shop 169 Road 101, Area 104, Al Hidd',
    phone: '+973 3984 1271',
    coordinates: { lat: 26.2471517, lng: 50.6529091 },
    timings: {
      openingTime: 9,     // 8 AM
      closingTime: 21.30,    // 8 PM
      breakStart: 13,     // 1 PM
      breakEnd: 16,       // 4 PM
      slotDuration: 30
    }
  },
  'galali': {
      name: 'Galali Branch',
      address: 'Avenue 13, Galali',
      phone: '+973 3984 1271',
      coordinates: { lat: 26.2723635, lng: 50.6480195 },
      timings: {
      openingTime: 9,     // 8 AM
      closingTime: 21.30,    // 8 PM
      breakStart: null,     // 1 PM
      breakEnd: null,       // 4 PM
      slotDuration: 30
      }
    },
    'janabiya': {
      name: 'Janabiya Branch',
      address: 'Building 108 Unit, 119 Avenue 79, Janabiyah 575',
      phone: '+973 3984 1271',
      coordinates: { lat: 26.178887, lng: 50.4779505 },
      timings: {
      openingTime: 8,     // 8 AM
      closingTime: 22,    // 8 PM
      breakStart: null,     // 1 PM
      breakEnd: null,       // 4 PM
      slotDuration: 30
      }
    },
    'amwaj': {
      name: 'Amwaj Branch',
      address: 'Building 873 Road 5815 Amwaj Islands, 258',
      phone: '+973 3984 1271',
      coordinates: { lat: 26.2779113, lng: 50.6593527 },
      timings: {
      openingTime: 9,     // 8 AM
      closingTime: 21.30,    // 8 PM
      breakStart: null,     // 1 PM
      breakEnd: null,       // 4 PM
      slotDuration: 30
      }
    }
};

  
  // Store opening and closing hours (24-hour format)
  const storeHours = {
    openingTime: 9, // 9 AM
    closingTime: 21.30, // 7 PM
    slotDuration: 30, // 30 minutes
  };
  
  // Map initialization and global variables
  let map;
  let markers = [];
  let userMarker = null;
  let selectedBranch = null;
  let selectedDate = null;
  let selectedTime = null;
  
  // Initialize Google Maps
  window.initMap = function() {
    try {
      // Check if Google Maps API is loaded
      if (typeof google === 'undefined' || typeof google.maps === 'undefined') {
        console.error('Google Maps API not loaded');
        document.getElementById('branch-map').innerHTML = '<div style="padding: 15px; background-color: #f8f9fa; text-align: center;">Map functionality is currently unavailable. Please select a branch from the dropdown.</div>';
        document.getElementById('find-nearest-store').disabled = true;
        return;
      }
      
      // Center map on Bahrain
      const bahrain = { lat: 26.1667, lng: 50.6333 };
      
      map = new google.maps.Map(document.getElementById('branch-map'), {
        center: bahrain,
        zoom: 10
      });
      
      // Add markers for all branches
      for (const branchId in branchData) {
        const branch = branchData[branchId];
        const marker = new google.maps.Marker({
          position: branch.coordinates,
          map: map,
          title: branch.name
        });
        
        // Add click event to marker
        marker.addListener('click', function() {
          selectBranch(branchId);
        });
        
        markers.push(marker);
      }
      
      // Enable "Find Nearest Store" button
      document.getElementById('find-nearest-store').disabled = false;
    } catch (error) {
      console.error('Error initializing Google Maps:', error);
      document.getElementById('branch-map').innerHTML = '<div style="padding: 15px; background-color: #f8f9fa; text-align: center;">Map functionality is currently unavailable. Please select a branch from the dropdown.</div>';
      document.getElementById('find-nearest-store').disabled = true;
    }
  };
  
  // Fallback for map initialization
  setTimeout(function() {
    if (typeof google === 'undefined' || typeof google.maps === 'undefined') {
      console.warn('Map not initialized, enabling branch selection without map');
      document.getElementById('branch-map').innerHTML = '<div style="padding: 15px; background-color: #f8f9fa; text-align: center;">Map functionality is currently unavailable. Please select a branch from the dropdown.</div>';
      document.getElementById('find-nearest-store').disabled = true;
    }
  }, 3000);
  
  // Event listeners
  const branchSelect = document.getElementById('branch-select');
  const findNearestStoreBtn = document.getElementById('find-nearest-store');

  const bookingForm = document.getElementById('eye-test-booking-form');
  const bookAnotherBtn = document.getElementById('book-another');
  
  // Branch selection
  branchSelect.addEventListener('change', function() {
    selectBranch(this.value);
  });
  
  // Find nearest store functionality
  findNearestStoreBtn.addEventListener('click', findNearestStore);
  
  // Date selection will be handled after date chips are generated
  
  
  
  
  
  // Form submission
  bookingForm.addEventListener('submit', function(e) {
    e.preventDefault();
    if (validateBookingForm()) {
      submitBooking();
    }
  });
  
  // Book another appointment
  bookAnotherBtn.addEventListener('click', function() {
    document.getElementById('booking-success').classList.add('hidden');
    document.getElementById('eye-test-booking-form').reset();
    document.getElementById('booking-form-container').classList.remove('hidden');
    document.getElementById('email-status').innerHTML = '';
    document.getElementById('email-status').className = 'email-status';
    
    // Reset selections
    selectedBranch = null;
    selectedDate = null;
    selectedTime = null;
    
    // Reset UI states
    document.querySelectorAll('.date-chip').forEach(chip => chip.classList.remove('selected'));
    document.getElementById('selected-branch-info').classList.add('hidden');
    document.getElementById('time-slots-container').innerHTML = '<p class="time-selection-message">Please select a date first</p>';
  });
  
  // Branch selection function
  function selectBranch(branchId) {
    if (!branchId) return;
    
    selectedBranch = branchId;
    
    // Update branch select dropdown
    branchSelect.value = branchId;
    
    // Center map on selected branch
    if (typeof map !== 'undefined' && map !== null) {
      map.setCenter(branchData[branchId].coordinates);
      map.setZoom(15);
      
      // Highlight the selected branch marker
      markers.forEach(marker => {
        if (marker.getTitle() === branchData[branchId].name) {
          marker.setAnimation(google.maps.Animation.BOUNCE);
          setTimeout(() => marker.setAnimation(null), 1500);
        }
      });
    }
    
    // Display branch info
    document.getElementById('branch-name').textContent = branchData[branchId].name;
    document.getElementById('branch-address').textContent = branchData[branchId].address;
    document.getElementById('branch-phone').textContent = branchData[branchId].phone;
    document.getElementById('selected-branch-info').classList.remove('hidden');
  }
  
  // Find nearest store function
  function findNearestStore() {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        function(position) {
          const userLocation = {
            lat: position.coords.latitude,
            lng: position.coords.longitude
          };
          
          // Add a marker for user's location
          if (userMarker) userMarker.setMap(null);
          
          userMarker = new google.maps.Marker({
            position: userLocation,
            map: map,
            title: 'Your Location',
            icon: {
              url: 'http://maps.google.com/mapfiles/ms/icons/blue-dot.png'
            }
          });
          
          // Find nearest branch
          let nearestBranch = null;
          let shortestDistance = Infinity;
          
          for (const branchId in branchData) {
            const branch = branchData[branchId];
            const distance = getDistance(
              userLocation.lat, userLocation.lng,
              branch.coordinates.lat, branch.coordinates.lng
            );
            
            if (distance < shortestDistance) {
              shortestDistance = distance;
              nearestBranch = branchId;
            }
          }
          
          // Select the nearest branch
          if (nearestBranch) {
            selectBranch(nearestBranch);
          }
        },
        function(error) {
          alert('Unable to get your location. Please select a branch manually.');
          console.error('Geolocation error:', error);
        }
      );
    } else {
      alert('Geolocation is not supported by your browser. Please select a branch manually.');
    }
  }
  
  // Calculate distance between two coordinates (Haversine formula)
  function getDistance(lat1, lng1, lat2, lng2) {
    const R = 6371; // Earth's radius in km
    const dLat = (lat2 - lat1) * Math.PI / 180;
    const dLng = (lng2 - lng1) * Math.PI / 180;
    const a = 
      Math.sin(dLat/2) * Math.sin(dLat/2) +
      Math.cos(lat1 * Math.PI / 180) * Math.cos(lat2 * Math.PI / 180) * 
      Math.sin(dLng/2) * Math.sin(dLng/2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a));
    return R * c;
  }
  
  // Date selection function
  function selectDate(date) {
    selectedDate = date;
    document.getElementById('selected-date').value = date;
    
    // Update date chips UI
    document.querySelectorAll('.date-chip').forEach(function(chip) {
      if (chip.dataset.date === date) {
        chip.classList.add('selected');
      } else {
        chip.classList.remove('selected');
      }
    });
    
    // Update calendar UI if visible
    const calendarDayElements = document.querySelectorAll('#calendar .calendar-day');
    calendarDayElements.forEach(function(day) {
      if (day.dataset.date === date) {
        day.classList.add('selected');
      } else {
        day.classList.remove('selected');
      }
    });
    
    // Generate time slots
    generateTimeSlots(date);
  }
  
  // Initialize calendar
  function initCalendar() {
    const calendarEl = document.getElementById('calendar');
    const today = new Date();
    const currentYear = today.getFullYear();
    const currentMonth = today.getMonth();
    
    // Generate calendar for current month
    generateCalendarMonth(calendarEl, currentYear, currentMonth);
  }
  
  // Generate calendar month
  function generateCalendarMonth(container, year, month) {
    const date = new Date(year, month, 1);
    const monthNames = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
    
    // Clear container
    container.innerHTML = '';
    
    // Create month header
    const monthHeader = document.createElement('div');
    monthHeader.className = 'calendar-header';
    monthHeader.innerHTML = `<h4>${monthNames[month]} ${year}</h4>`;
    container.appendChild(monthHeader);
    
    // Create weekday header
    const weekdayHeader = document.createElement('div');
    weekdayHeader.className = 'calendar-weekdays';
    weekdayHeader.innerHTML = '<div>Sun</div><div>Mon</div><div>Tue</div><div>Wed</div><div>Thu</div><div>Fri</div><div>Sat</div>';
    container.appendChild(weekdayHeader);
    
    // Create calendar grid
    const calendarGrid = document.createElement('div');
    calendarGrid.className = 'calendar-grid';
    
    const today = new Date();
    const firstDay = new Date(year, month, 1).getDay();
    const daysInMonth = new Date(year, month + 1, 0).getDate();
    
    // Add empty cells for days before the first day of the month
    for (let i = 0; i < firstDay; i++) {
      const emptyDay = document.createElement('div');
      emptyDay.className = 'calendar-day empty';
      calendarGrid.appendChild(emptyDay);
    }
    
    // Add days of the month
    for (let i = 1; i <= daysInMonth; i++) {
      const dayEl = document.createElement('div');
      const currentDate = new Date(year, month, i);
      const dateStr = formatDate(currentDate);
      
      dayEl.className = 'calendar-day';
      dayEl.textContent = i;
      dayEl.dataset.date = dateStr;
      
      // Disable past dates
      if (currentDate < new Date(today.getFullYear(), today.getMonth(), today.getDate())) {
        dayEl.classList.add('disabled');
      } else {
        dayEl.addEventListener('click', function() {
          selectDate(dateStr);
        });
        
        // Highlight selected date
        if (selectedDate === dateStr) {
          dayEl.classList.add('selected');
        }
      }
      
      calendarGrid.appendChild(dayEl);
    }
    
    container.appendChild(calendarGrid);
    
    // Add calendar styles
    if (!document.getElementById('calendar-styles')) {
      const calendarStyles = document.createElement('style');
      calendarStyles.id = 'calendar-styles';
      calendarStyles.innerHTML = `
        .calendar-header {
          text-align: center;
          margin-bottom: 15px;
        }
        .calendar-weekdays {
          display: grid;
          grid-template-columns: repeat(7, 1fr);
          text-align: center;
          font-weight: bold;
          margin-bottom: 5px;
        }
        .calendar-grid {
          display: grid;
          grid-template-columns: repeat(7, 1fr);
          gap: 5px;
        }
        .calendar-day {
          height: 35px;
          display: flex;
          align-items: center;
          justify-content: center;
          border-radius: 50%;
          cursor: pointer;
          transition: all 0.2s ease;
        }
        .calendar-day:hover:not(.empty):not(.disabled) {
          background-color: #ebf8ff;
        }
        .calendar-day.selected {
          background-color: #3182ce;
          color: white;
        }
        .calendar-day.disabled {
          color: #cbd5e0;
          cursor: not-allowed;
        }
        .calendar-day.empty {
          visibility: hidden;
        }
      `;
      document.head.appendChild(calendarStyles);
    }
  }
  
  // Format date as YYYY-MM-DD
  function formatDate(date) {
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const day = date.getDate().toString().padStart(2, '0');
    return `${year}-${month}-${day}`;
  }
  
  // Generate time slots based on selected date and branch-specific timings
function generateTimeSlots(date) {
  if (!selectedBranch) {
    const timeContainer = document.getElementById('time-slots-container');
    timeContainer.innerHTML = '<p class="time-selection-message">Please select a branch first</p>';
    return;
  }
  
  const timeContainer = document.getElementById('time-slots-container');
  timeContainer.innerHTML = '';
  
  const selectedDateObj = new Date(date);
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  
  // Get branch-specific timings
  const branchTimings = branchData[selectedBranch].timings;
  let startHour = branchTimings.openingTime;
  
  // If today is selected, start from current hour + 1 (if within opening hours)
  if (selectedDateObj.getTime() === today.getTime()) {
    const currentHour = new Date().getHours();
    const currentMinute = new Date().getMinutes();
    
    if (currentHour >= branchTimings.openingTime) {
      startHour = currentHour;
      // If we're past the current minute, start from next slot
      if (currentMinute > 0) {
        startHour = currentHour + 1;
      }
    }
  }
  
  // Create time slots wrapper
  const timeSlots = document.createElement('div');
  timeSlots.classList.add('time-slots-grid');
  let slotsAdded = 0;
  
  // Helper function to add time slots for a given time range
  function addSlotsForRange(rangeStartHour, rangeEndHour) {
    for (let hour = rangeStartHour; hour < rangeEndHour; hour++) {
      for (let min = 0; min < 60; min += branchTimings.slotDuration) {
        // Skip if this is a past time slot for today
        if (selectedDateObj.getTime() === today.getTime()) {
          const now = new Date();
          const slotTime = new Date(selectedDateObj);
          slotTime.setHours(hour, min, 0, 0);
          
          if (slotTime <= now) {
            continue;
          }
        }
        
        const timeStr = formatTimeString(hour, min);
        const timeValue = `<span class="katex"><span class="katex-mathml"><math xmlns="http://www.w3.org/1998/Math/MathML"><semantics><mrow><mrow><mi>S</mi><mi>t</mi><mi>r</mi><mi>i</mi><mi>n</mi><mi>g</mi><mo stretchy="false">(</mo><mi>h</mi><mi>o</mi><mi>u</mi><mi>r</mi><mo stretchy="false">)</mo><mi mathvariant="normal">.</mi><mi>p</mi><mi>a</mi><mi>d</mi><mi>S</mi><mi>t</mi><mi>a</mi><mi>r</mi><mi>t</mi><mo stretchy="false">(</mo><mn>2</mn><msup><mo separator="true">,</mo><mo mathvariant="normal" lspace="0em" rspace="0em">′</mo></msup><msup><mn>0</mn><mo mathvariant="normal" lspace="0em" rspace="0em">′</mo></msup><mo stretchy="false">)</mo></mrow><mo>:</mo></mrow><annotation encoding="application/x-tex">{String(hour).padStart(2, &#x27;0&#x27;)}:</annotation></semantics></math></span><span class="katex-html" aria-hidden="true"><span class="base"><span class="strut" style="height:1.0019em;vertical-align:-0.25em;"></span><span class="mord"><span class="mord mathnormal">St</span><span class="mord mathnormal" style="margin-right:0.02778em;">r</span><span class="mord mathnormal">in</span><span class="mord mathnormal" style="margin-right:0.03588em;">g</span><span class="mopen">(</span><span class="mord mathnormal">h</span><span class="mord mathnormal">o</span><span class="mord mathnormal">u</span><span class="mord mathnormal" style="margin-right:0.02778em;">r</span><span class="mclose">)</span><span class="mord">.</span><span class="mord mathnormal">p</span><span class="mord mathnormal">a</span><span class="mord mathnormal">d</span><span class="mord mathnormal">St</span><span class="mord mathnormal">a</span><span class="mord mathnormal" style="margin-right:0.02778em;">r</span><span class="mord mathnormal">t</span><span class="mopen">(</span><span class="mord">2</span><span class="mpunct"><span class="mpunct">,</span><span class="msupsub"><span class="vlist-t"><span class="vlist-r"><span class="vlist" style="height:0.7519em;"><span style="top:-3.063em;margin-right:0.05em;"><span class="pstrut" style="height:2.7em;"></span><span class="sizing reset-size6 size3 mtight"><span class="mord mtight"><span class="mord mtight">′</span></span></span></span></span></span></span></span></span><span class="mspace" style="margin-right:0.1667em;"></span><span class="mord"><span class="mord">0</span><span class="msupsub"><span class="vlist-t"><span class="vlist-r"><span class="vlist" style="height:0.7519em;"><span style="top:-3.063em;margin-right:0.05em;"><span class="pstrut" style="height:2.7em;"></span><span class="sizing reset-size6 size3 mtight"><span class="mord mtight"><span class="mord mtight">′</span></span></span></span></span></span></span></span></span><span class="mclose">)</span></span><span class="mspace" style="margin-right:0.2778em;"></span><span class="mrel">:</span></span></span></span>{String(min).padStart(2, '0')}`;

        const timeSlot = document.createElement('div');
        timeSlot.className = 'time-slot';
        timeSlot.textContent = timeStr;
        timeSlot.dataset.time = timeValue;
        timeSlot.dataset.displayTime = timeStr;
        
        timeSlot.addEventListener('click', function() {
  selectTime(this.dataset.time, this.dataset.displayTime, this);
});

        
        timeSlots.appendChild(timeSlot);
        slotsAdded++;
      }
    }
  }
  
  // Check if branch has break times
  const hasBreak = branchTimings.breakStart !== null && branchTimings.breakEnd !== null;
  
  if (hasBreak) {
    // Generate morning slots (before break)
    const morningEndHour = Math.min(branchTimings.breakStart, branchTimings.closingTime);
    if (startHour < morningEndHour) {
      addSlotsForRange(startHour, morningEndHour);
    }
    
    // Add break indicator if there are morning slots and afternoon slots
    if (startHour < branchTimings.breakStart && branchTimings.breakEnd < branchTimings.closingTime) {
      const breakIndicator = document.createElement('div');
      breakIndicator.className = 'break-indicator';
      breakIndicator.innerHTML = `
  <span class="break-text">Break Time</span>
`;

      timeSlots.appendChild(breakIndicator);
    }
    
    // Generate afternoon/evening slots (after break)
    const afternoonStartHour = Math.max(branchTimings.breakEnd, startHour);
    if (afternoonStartHour < branchTimings.closingTime) {
      addSlotsForRange(afternoonStartHour, branchTimings.closingTime);
    }
  } else {
    // No break - generate slots for the entire operating period
    addSlotsForRange(startHour, branchTimings.closingTime);
  }
  
  if (slotsAdded > 0) {
    timeContainer.appendChild(timeSlots);
  } else {
    // If no slots available
    const noSlotsMessage = document.createElement('div');
    noSlotsMessage.className = 'no-slots-message';
    
    if (hasBreak) {
      const breakStart = formatTimeString(branchTimings.breakStart, 0);
      const breakEnd = formatTimeString(branchTimings.breakEnd, 0);
      noSlotsMessage.innerHTML = `
        <p class="time-selection-message">No available slots for this date.</p>
       
        <p class="time-selection-message">Please select another date.</p>
      `;
    } else {
      noSlotsMessage.innerHTML = `
        <p class="time-selection-message">No available slots for this date.</p>
        <p class="branch-timing-info">
          <strong><span class="katex"><span class="katex-mathml"><math xmlns="http://www.w3.org/1998/Math/MathML"><semantics><mrow><mrow><mi>b</mi><mi>r</mi><mi>a</mi><mi>n</mi><mi>c</mi><mi>h</mi><mi>D</mi><mi>a</mi><mi>t</mi><mi>a</mi><mo stretchy="false">[</mo><mi>s</mi><mi>e</mi><mi>l</mi><mi>e</mi><mi>c</mi><mi>t</mi><mi>e</mi><mi>d</mi><mi>B</mi><mi>r</mi><mi>a</mi><mi>n</mi><mi>c</mi><mi>h</mi><mo stretchy="false">]</mo><mi mathvariant="normal">.</mi><mi>n</mi><mi>a</mi><mi>m</mi><mi>e</mi></mrow><mi>H</mi><mi>o</mi><mi>u</mi><mi>r</mi><mi>s</mi><mo>:</mo><mo>&lt;</mo><mi mathvariant="normal">/</mi><mi>s</mi><mi>t</mi><mi>r</mi><mi>o</mi><mi>n</mi><mi>g</mi><mo>&gt;</mo><mo>&lt;</mo><mi>b</mi><mi>r</mi><mo>&gt;</mo></mrow><annotation encoding="application/x-tex">{branchData[selectedBranch].name} Hours:&lt;/strong&gt;&lt;br&gt;</annotation></semantics></math></span><span class="katex-html" aria-hidden="true"><span class="base"><span class="strut" style="height:1em;vertical-align:-0.25em;"></span><span class="mord"><span class="mord mathnormal">b</span><span class="mord mathnormal" style="margin-right:0.02778em;">r</span><span class="mord mathnormal">an</span><span class="mord mathnormal">c</span><span class="mord mathnormal">h</span><span class="mord mathnormal" style="margin-right:0.02778em;">D</span><span class="mord mathnormal">a</span><span class="mord mathnormal">t</span><span class="mord mathnormal">a</span><span class="mopen">[</span><span class="mord mathnormal">se</span><span class="mord mathnormal" style="margin-right:0.01968em;">l</span><span class="mord mathnormal">ec</span><span class="mord mathnormal">t</span><span class="mord mathnormal">e</span><span class="mord mathnormal">d</span><span class="mord mathnormal" style="margin-right:0.05017em;">B</span><span class="mord mathnormal" style="margin-right:0.02778em;">r</span><span class="mord mathnormal">an</span><span class="mord mathnormal">c</span><span class="mord mathnormal">h</span><span class="mclose">]</span><span class="mord">.</span><span class="mord mathnormal">nam</span><span class="mord mathnormal">e</span></span><span class="mord mathnormal">Ho</span><span class="mord mathnormal">u</span><span class="mord mathnormal">rs</span><span class="mspace" style="margin-right:0.2778em;"></span><span class="mrel">:&lt;</span><span class="mspace" style="margin-right:0.2778em;"></span></span><span class="base"><span class="strut" style="height:1em;vertical-align:-0.25em;"></span><span class="mord">/</span><span class="mord mathnormal">s</span><span class="mord mathnormal">t</span><span class="mord mathnormal">ro</span><span class="mord mathnormal">n</span><span class="mord mathnormal" style="margin-right:0.03588em;">g</span><span class="mspace" style="margin-right:0.2778em;"></span><span class="mrel">&gt;&lt;</span><span class="mspace" style="margin-right:0.2778em;"></span></span><span class="base"><span class="strut" style="height:0.7335em;vertical-align:-0.0391em;"></span><span class="mord mathnormal">b</span><span class="mord mathnormal" style="margin-right:0.02778em;">r</span><span class="mspace" style="margin-right:0.2778em;"></span><span class="mrel">&gt;</span></span></span></span>{formatTimeString(branchTimings.openingTime, 0)} - ${formatTimeString(branchTimings.closingTime, 0)}
        </p>
        <p class="time-selection-message">Please select another date.</p>
      `;
    }
    
    timeContainer.appendChild(noSlotsMessage);
  }
}

  
  // Format time as 12-hour format (e.g., "9:00 AM")
  function formatTimeString(hour, minute) {
    const period = hour >= 12 ? 'PM' : 'AM';
    const displayHour = hour % 12 || 12;
    const displayMinute = minute.toString().padStart(2, '0');
    return `${displayHour}:${displayMinute} ${period}`;
  }
  
  function selectTime(timeValue, displayTime, clickedElement) {
  selectedTime = timeValue;
  document.getElementById('selected-time').value = timeValue;
  
  // Store the display time for later use
  if (displayTime) {
    selectedTimeDisplay = displayTime;
  } else {
    // Generate display time from the value if not provided
    const timeParts = timeValue.split(':');
    if (timeParts.length === 2) {
      const hour = parseInt(timeParts[0]);
      const minute = parseInt(timeParts[1]);
      selectedTimeDisplay = formatTimeString(hour, minute);
    }
  }
  
  // Update UI - Remove selected class from all time slots first
  document.querySelectorAll('.time-slot').forEach(function(slot) {
    slot.classList.remove('selected');
  });

  // Add selected class only to the clicked time slot
  if (clickedElement) {
    clickedElement.classList.add('selected');
  }
} // <- Make sure this closing bracket exists


  
  // Form validation
  function validateBookingForm() {
    // Check if branch is selected
    if (!selectedBranch) {
      alert('Please select a branch');
      return false;
    }
    
    // Check if date is selected
    if (!selectedDate) {
      alert('Please select a date for your appointment');
      return false;
    }
    
    // Check if time is selected
    if (!selectedTime) {
      alert('Please select a time for your appointment');
      return false;
    }
    
    // Check customer details
    const customerName = document.getElementById('customer-name').value.trim();
    const customerEmail = document.getElementById('customer-email').value.trim();
    const customerPhone = document.getElementById('customer-phone').value.trim();
    
    if (!customerName) {
      alert('Please enter your name');
      return false;
    }
    
    if (!customerEmail || !isValidEmail(customerEmail)) {
      alert('Please enter a valid email address');
      return false;
    }
    
    if (!customerPhone) {
      alert('Please enter your phone number');
      return false;
    }
    
    return true;
  }
  
  // Email validation
  function isValidEmail(email) {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  }
  
  // Function to generate date chips for the next 7 days
  function generateDateChips() {
    const dateRangeContainer = document.getElementById('dynamic-date-range');
    if (!dateRangeContainer) return;

    dateRangeContainer.innerHTML = '';
    
    // Add today
    const today = new Date();
    const todayFormatted = formatDate(today);
    
    const todayChip = document.createElement('div');
    todayChip.className = 'date-chip';
    todayChip.dataset.date = todayFormatted;
    todayChip.innerHTML = `Today<br>${today.getDate()} ${getMonthAbbr(today)}`;
    todayChip.addEventListener('click', function() {
      selectDate(this.dataset.date);
    });
    dateRangeContainer.appendChild(todayChip);
    
    // Add next 6 days
    for (let i = 1; i <= 6; i++) {
      const date = new Date();
      date.setDate(today.getDate() + i);
      const dateFormatted = formatDate(date);
      
      const dateChip = document.createElement('div');
      dateChip.className = 'date-chip';
      dateChip.dataset.date = dateFormatted;
      dateChip.innerHTML = `${getWeekdayAbbr(date)}<br>${date.getDate()} ${getMonthAbbr(date)}`;
      dateChip.addEventListener('click', function() {
        selectDate(this.dataset.date);
      });
      dateRangeContainer.appendChild(dateChip);
    }
  }
  
  // Helper function to get month abbreviation
  function getMonthAbbr(date) {
    const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    return months[date.getMonth()];
  }
  
  // Helper function to get weekday abbreviation
  function getWeekdayAbbr(date) {
    const days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
    return days[date.getDay()];
  }

  // Modified submitBooking function to use EmailJS
  function submitBooking() {
    const formData = new FormData(document.getElementById('eye-test-booking-form'));
    
    // Validate critical data is available
    if (!selectedBranch || !branchData[selectedBranch]) {
      console.error("Missing branch data");
      alert('Please select a branch first');
      return;
    }
    
    if (!selectedTime) {
      console.error("Missing time selection");
      alert('Please select an appointment time');
      return;
    }
    
    // Ensure we have a display time for the selected time slot
    let timeDisplayValue = selectedTime; // Default fallback
    
    if (selectedTimeDisplay && selectedTimeDisplay !== '') {
      timeDisplayValue = selectedTimeDisplay;
    } else {
      // Generate display time from the time value
      try {
        const timeParts = selectedTime.split(':');
        if (timeParts.length === 2) {
          const hour = parseInt(timeParts[0], 10);
          const minute = parseInt(timeParts[1], 10);
          timeDisplayValue = formatTimeString(hour, minute);
          selectedTimeDisplay = timeDisplayValue; // Update the global variable
        }
      } catch (error) {
        console.error('Error formatting time:', error);
      }
    }
    
    // Get customer details
    const customerName = formData.get('customer_name');
    const customerEmail = formData.get('customer_email');
    const countryCode = formData.get('country_code');
    const customerPhone = formData.get('customer_phone');
    const additionalNotes = formData.get('additional_notes') || '';
    
    // Get Shopify section settings
    const sectionElement = document.querySelector('#eye-test-booking-section');
    const adminEmail = sectionElement ? sectionElement.dataset.adminEmail : 'admin@rathodopticians.com';
    
    // Prepare booking data for emails
    const bookingData = {
      branch_id: selectedBranch,
      branch_name: branchData[selectedBranch].name,
      branch_address: branchData[selectedBranch].address,
      date: selectedDate,
      date_display: formatDisplayDate(selectedDate),
      time: selectedTime,
      time_display: timeDisplayValue,
      customer_name: customerName,
      customer_email: customerEmail,
      customer_phone: `${countryCode} ${customerPhone}`,
      additional_notes: additionalNotes || null,
      admin_email: adminEmail
    };
    
    // Show loading state
    const submitButton = document.getElementById('book-eye-test-btn');
    const originalButtonText = submitButton.textContent;
    submitButton.disabled = true;
    submitButton.textContent = 'Processing...';
    
    // Update email status
    const emailStatus = document.getElementById('email-status');
    emailStatus.innerHTML = '<div class="email-sending">Sending confirmation emails<span class="loading-dots"></span></div>';
    
    // Get EmailJS settings from section data attributes
const emailjsSettings = {
  service_id: sectionElement.dataset.emailjsServiceId || '',
  admin_template_id: sectionElement.dataset.emailjsAdminTemplate || '',
  customer_template_id: sectionElement.dataset.emailjsCustomerTemplate || ''
};

// Add validation to prevent errors
if (!emailjsSettings.service_id || !emailjsSettings.admin_template_id || !emailjsSettings.customer_template_id) {
  console.error("Missing EmailJS configuration", emailjsSettings);
  alert('Email configuration error. Please contact the administrator.');
  
  // Reset button state
  submitButton.disabled = false;
  submitButton.textContent = originalButtonText;
  
  // Update email status
  emailStatus.innerHTML = '<div class="email-status error">Email configuration error. Please contact the administrator.</div>';
  return;
}
    
    // Send email to admin
const adminEmailPromise = emailjs.send(
  emailjsSettings.service_id,
  emailjsSettings.admin_template_id,
  {
    admin_email: bookingData.admin_email,
    customer_name: bookingData.customer_name,
    customer_email: bookingData.customer_email,
    customer_phone: bookingData.customer_phone,
    branch_name: bookingData.branch_name,
    branch_address: bookingData.branch_address,
    appointment_date: bookingData.date_display,
    appointment_time: bookingData.time_display,
    additional_notes: bookingData.additional_notes || '' // Use empty string if null
  }
);
    
    // Send email to customer
const customerEmailPromise = emailjs.send(
  emailjsSettings.service_id,
  emailjsSettings.customer_template_id,
  {
    to_email: bookingData.customer_email,
    to_name: bookingData.customer_name,
    branch_name: bookingData.branch_name,
    branch_address: bookingData.branch_address,
    appointment_date: bookingData.date_display,
    appointment_time: bookingData.time_display,
    customer_phone: bookingData.customer_phone,
    additional_notes: bookingData.additional_notes,
    reply_to: adminEmail  // Add this line to ensure reply-to is set
  }
);

    
    // Handle both email sends
    Promise.all([adminEmailPromise, customerEmailPromise])
      .then(() => {
        // Reset button state
        submitButton.disabled = false;
        submitButton.textContent = originalButtonText;
        
        // Show success message
        document.getElementById('booking-form-container').classList.add('hidden');
        document.getElementById('confirmation-branch').textContent = bookingData.branch_name;
        document.getElementById('confirmation-date').textContent = bookingData.date_display;
        document.getElementById('confirmation-time').textContent = bookingData.time_display;
        document.getElementById('booking-success').classList.remove('hidden');
        
        // Update email status
        emailStatus.innerHTML = '<div class="email-status success">Confirmation emails sent successfully!</div>';
        
        console.log('Booking emails sent successfully!');
      })
      .catch(error => {
        // Handle errors
        console.error('Error sending emails:', error);
        
        // Reset button state
        submitButton.disabled = false;
        submitButton.textContent = originalButtonText;
        
        // Show booking confirmation but with email error
        document.getElementById('booking-form-container').classList.add('hidden');
        document.getElementById('confirmation-branch').textContent = bookingData.branch_name;
        document.getElementById('confirmation-date').textContent = bookingData.date_display;
        document.getElementById('confirmation-time').textContent = bookingData.time_display;
        document.getElementById('booking-success').classList.remove('hidden');
        
        // Update email status
        emailStatus.innerHTML = '<div class="email-status error">Failed to send confirmation emails. Please contact us.</div>';
      });
  }
  
  // Format date for display (e.g., "Monday, July 15, 2025")
  function formatDisplayDate(dateStr) {
    const options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
    return new Date(dateStr).toLocaleDateString(undefined, options);
  }
});